import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSafeGateway } from '@tectonics/prs/core/gateway';

export function getGatewayBankCode(incomingPayment: PendingIncomingPayment): string | null | undefined {
  const gateway = getSafeGateway(incomingPayment);
  return gateway['bank_code'];
}

export function getSafeGatewayBankCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayBankCode(incomingPayment);

  if (!code) {
    throw new Error('getSafeGatewayBankCode - there is no bank code in the incoming payment');
  }

  return code;
}
